import src from "IMAGE";
export default { src, width: 3000, height: 1858, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAPElEQVR42o3MOw4AEBCE4SXxPI2OSqF0/wP5yRY6Jvmy2WJG5DMJWa9H1P/EoqJhYqCjwNwLQVt7wal3FpNdAcverU7sAAAAAElFTkSuQmCC"};
